var $3c5ec8e4f015dfd0$exports = {};
$3c5ec8e4f015dfd0$exports = {
  "ascending": "crescente",
  "ascendingSort": function ascendingSort(args) {
    return "in ordine crescente in base alla colonna ".concat(args.columnName);
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " pixel");
  },
  "descending": "decrescente",
  "descendingSort": function descendingSort(args) {
    return "in ordine decrescente in base alla colonna ".concat(args.columnName);
  },
  "resizerDescription": "Premi Invio per iniziare a ridimensionare",
  "select": "Seleziona",
  "selectAll": "Seleziona tutto",
  "sortable": "colonna ordinabile"
};
export { $3c5ec8e4f015dfd0$exports as default };